import LocationsMenu from './LocationsMenu';

export default LocationsMenu;
